import { PathInput } from "@/modules/admin-panel/bpm-routes/shared/ui/path-input";
import Form, { FormProps } from "@/shared/form/form";
import { ROUTE } from "../../model/use-form";
import { PathFormInput } from "../../model/types";
import { HiddenFieldsAlert } from "@/shared/value";

export function PathForm({
  hasHiddenSteps,
  ...props
}: FormProps<PathFormInput> & { hasHiddenSteps?: boolean }) {
  return (
    <>
      {hasHiddenSteps && <HiddenFieldsAlert />}

      <Form
        name={ROUTE}
        layout="vertical"
        {...props}
        disabled={props.disabled || hasHiddenSteps}
      >
        <PathInput name="route" />
      </Form>
    </>
  );
}
